<template>
  <f7-list v-if="dcs.length > 0">
    <f7-list-item
      accordion-item
      class="main-complementary-data"
      :accordion-item-opened="true"
      :opened="true"
      :title="$t('common.supplementaryData')"
    >
      <f7-accordion-content>
        <f7-list>
          <!-- <f7-list-input
            v-for="dc in dcs"
            :key="dc.code"
            :label="dc.name"
            :placeholder="dc.name"
            validate
            :required="dc.required"
            :value="localData[dc.code]"
            type="text"
            @change="onInputChange(dc.code, $event.target.value)"
          /> -->
          <ComplementaryDataInput
            v-for="dc in dcs"
            :key="dc.code"
            :dc="dc"
            :value="localData[dc.code]"
            @value-change="onInputChange"
          />
        </f7-list>
      </f7-accordion-content>
    </f7-list-item>
  </f7-list>
</template>

<script>
import MasterDataService from '@/js/services/contracts/MasterData';
import ComplementaryDataInput from './ComplementaryDataInput.vue';

export default {
  name: 'ComplementaryData',
  components: {
    ComplementaryDataInput,
  },
  props: {
    entity: { type: Number, default: 0 },
    dcsData: { type: Object, default: undefined },
  },

  emits: ['data-changed'],

  data() {
    return {
      dcs: [],
      localData: {},
    };
  },
  watch: {
    dcsData() {
      this.localData = this.dcsData;
    },
  },

  async mounted() {
    await this.loadComplementaryData();
    this.localData = this.dcsData;
  },
  methods: {
    async loadComplementaryData() {
      if (this.entity > 0) {
        const entityDcs = await MasterDataService.getDCByEntity(this.entity);

        this.dcs = entityDcs;
      }
    },
    onInputChange({ dcCode, value }) {
      this.localData[dcCode] = value;
      this.$emit('data-changed', this.localData);
    },

  },
};
</script>
